import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/nps/:id',
        name: 'evaluation',
        component: () => import('../views/EvaluationPage.vue')
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL || '/',
    routes
})

// Обработка ошибок навигации
router.onError((error) => {
    console.error('Router error:', error)
})

export default router
